export const DIRECTION = {
	direct: 'direct',
	reverse: 'reverse',
}
